export default __webpack_public_path__ + "static/Saira-Thin-f3d5b91d5b8965a75588c4efcce797b5.woff2";